import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getSystemConfigsDataTable: ApiMethod<
  Server.SystemConfigDatatable,
  Server.TableOfSystemConfigColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_SystemConfig_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_SystemConfig_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const getSystemConfigById: ApiMethod<
  number,
  Server.SystemConfigOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_SystemConfig_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_SystemConfig_byId_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};

export const editSystemConfig: ApiMethod<
  Server.UpdateSystemConfigInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_SystemConfig_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_SystemConfig_put_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        for: 'modal',
        type: AlertType.WARNING,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(error);
  }
};
